enum OrdonnanceStatus {
	PREPARING = 'PREPARING', 
	BILLED = 'BILLED', 
	PAID = 'PAID'
}

export default OrdonnanceStatus;